module.exports = __webpack_public_path__ + "static/media/Livre3new.e2c37c7c.png";